var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#696969",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 373.031 373.031",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.367,77.501c2.761,0,5-2.239,5-5V49.659c0-5.214,4.242-9.457,9.457-9.457h54.86v20.07H90.001c-2.761,0-5,2.239-5,5 v258.21c0,2.761,2.239,5,5,5h193.66c2.761,0,5-2.239,5-5V65.272c0-2.761-2.239-5-5-5h-41.311v-20.07h53.871 c5.205,0,9.44,4.244,9.44,9.46v270.39c0,2.761,2.239,5,5,5s5-2.239,5-5V49.662c0-10.73-8.721-19.46-19.44-19.46h-53.871v-7.869 c0-2.761-2.239-5-5-5h-19.737C211.219,6.709,199.535,0,187.017,0s-24.202,6.709-30.596,17.333h-19.737c-2.761,0-5,2.239-5,5v7.869 h-54.86c-10.729,0-19.457,8.728-19.457,19.457v22.843C57.367,75.263,59.606,77.501,62.367,77.501z M136.684,81.333h57.001 c2.761,0,5-2.239,5-5s-2.239-5-5-5h-52.001v-44h17.71c1.917,0,3.667-1.097,4.501-2.823C168.158,15.696,177.234,10,187.017,10 s18.859,5.696,23.122,14.51c0.835,1.726,2.584,2.823,4.501,2.823h17.71v44h-19.666c-2.761,0-5,2.239-5,5s2.239,5,5,5h24.666 c2.761,0,5-2.239,5-5v-6.061h36.311v248.21H95.001V70.272h36.683v6.061C131.684,79.095,133.922,81.333,136.684,81.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.373,83.953c-2.761,0-5,2.239-5,5v6.818c0,2.761,2.239,5,5,5s5-2.239,5-5v-6.818 C67.373,86.191,65.134,83.953,62.373,83.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.664,332.755c-2.761,0-5,2.239-5,5v15.827c0,5.21-4.239,9.449-9.449,9.449H76.822c-5.21,0-9.449-4.239-9.449-9.449 V112.223c0-2.761-2.239-5-5-5s-5,2.239-5,5v241.359c0,10.724,8.725,19.449,19.449,19.449h219.393 c10.724,0,19.449-8.725,19.449-19.449v-15.827C315.664,334.994,313.425,332.755,310.664,332.755z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.352,279.582H117.648c-2.761,0-5,2.239-5,5s2.239,5,5,5h140.704c2.761,0,5-2.239,5-5S261.113,279.582,258.352,279.582z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.352,219.044H117.648c-2.761,0-5,2.239-5,5s2.239,5,5,5h140.704c2.761,0,5-2.239,5-5S261.113,219.044,258.352,219.044z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.648,259.461h16.549c2.761,0,5-2.239,5-5s-2.239-5-5-5h-16.549c-2.761,0-5,2.239-5,5S114.887,259.461,117.648,259.461z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.344,259.461c2.761,0,5-2.239,5-5s-2.239-5-5-5h-8.824c-2.761,0-5,2.239-5,5s2.239,5,5,5H157.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.352,249.461h-86.91c-2.761,0-5,2.239-5,5s2.239,5,5,5h86.91c2.761,0,5-2.239,5-5S261.113,249.461,258.352,249.461z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.825,198.775h75.688c2.761,0,5-2.239,5-5s-2.239-5-5-5h-75.688c-2.761,0-5,2.239-5,5S115.064,198.775,117.825,198.775z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.352,188.775h-50.768c-2.761,0-5,2.239-5,5s2.239,5,5,5h50.768c2.761,0,5-2.239,5-5S261.113,188.775,258.352,188.775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.352,158.506H117.648c-2.761,0-5,2.239-5,5s2.239,5,5,5h140.704c2.761,0,5-2.239,5-5S261.113,158.506,258.352,158.506z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.642,138.148c-4.582,0.06-21.386,0.06-26.058,0c-2.761-0.035-4.971-2.302-4.936-5.063 c0.035-2.761,2.29-4.944,5.063-4.936c9.253,0.118,16.729,0.118,25.801,0c2.75-0.022,5.028,2.173,5.064,4.935 C148.612,135.845,146.403,138.112,143.642,138.148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.335,129.174c0.029,0.022,0.082,0.062,0.11,0.084c1.672,1.317,2.327,3.548,1.632,5.56 c-0.694,2.012-2.586,3.364-4.714,3.368c-14.243,0.033-80.108,0.021-98.859-0.037c-2.758-0.009-4.989-2.249-4.984-5.008 c0.004-2.758,2.242-4.992,5-4.992h98.783C259.424,128.149,260.453,128.479,261.335,129.174z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.831,
    cy: 30.396,
    r: 9.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.630b65c621fe1882682c065a024bf534.svg";
export { ForwardRef as ReactComponent };